(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-bf-savings"] && !Shopify.designMode) return;
  try {
    
if (!window.__mtBfCopyBound) {
  window.__mtBfCopyBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bf-copy]');
    if (!button) return;
    var code = button.getAttribute('data-bf-copy') || '';
    var label = button.querySelector('[data-bf-copy-label]');
    var copied = button.getAttribute('data-bf-copied') || 'Copied';
    var original = button.getAttribute('data-bf-label') || '';

    function showCopied() {
      if (!label) return;
      label.textContent = copied;
      window.clearTimeout(button.__mtBfCopyTimer);
      button.__mtBfCopyTimer = window.setTimeout(function () {
        label.textContent = original;
      }, 1600);
    }

    function fallbackCopy() {
      var input = document.createElement('textarea');
      input.value = code;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        showCopied();
      } catch (error) {}
      document.body.removeChild(input);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(showCopied).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-subscribe-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-subscribe-popup')) {
    customElements.define('mt-subscribe-popup', class extends HTMLElement {
      connectedCallback() {
        this.overlay = this.querySelector('[data-sp-overlay]');
        this.dialog = this.querySelector('[data-sp-dialog]');
        this.tab = this.querySelector('[data-sp-tab]');
        this.form = this.querySelector('.mt-subpop__form');
        this.key = this.dataset.key || 'mt-subpop';
        this.designMode = this.dataset.designMode === 'true';

        this.querySelectorAll('[data-sp-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.overlay.addEventListener('click', () => this.close());
        this.querySelectorAll('[data-sp-open]').forEach((b) => b.addEventListener('click', () => this.open()));
        var tabClose = this.querySelector('[data-sp-tab-close]');
        if (tabClose) tabClose.addEventListener('click', () => { this.store('session', 'tab-hidden', '1'); this.showTab(false); });
        if (this.form) this.form.addEventListener('submit', (e) => this.submit(e));
        var copy = this.querySelector('[data-sp-copy]');
        if (copy) copy.addEventListener('click', () => this.copyCode(copy));
        var apply = this.querySelector('[data-sp-apply]');
        if (apply) apply.addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = '/discount/' + apply.dataset.spApply + '?redirect=' + encodeURIComponent(new URL(apply.href, window.location.origin).pathname);
        });

        this.onKey = (e) => {
          if (!this.classList.contains('is-open')) return;
          if (e.key === 'Escape') this.close();
          if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this.onKey);

        if (this.designMode) {
          this.addEventListener('shopify:section:select', () => this.open());
          this.addEventListener('shopify:section:deselect', () => this.close(true));
          this.showTab(true);
          return;
        }
        this.init();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        clearTimeout(this.timer);
      }

      store(type, name, value) {
        var area = type === 'session' ? window.sessionStorage : window.localStorage;
        var k = this.key + ':' + name;
        try {
          if (value === undefined) return area.getItem(k);
          if (value === null) area.removeItem(k);
          else area.setItem(k, value);
        } catch (e) { return null; }
      }

      init() {
        if (this.store('session', 'pending') && !/\/challenge/.test(window.location.pathname)) {
          this.store('session', 'pending', null);
          var serverError = this.querySelector('[data-sp-server-error]');
          var posted = this.querySelector('[data-sp-posted]') || /customer_posted=true/.test(window.location.search);
          if (serverError || posted) {
            this.open();
            if (serverError) this.showError(serverError.textContent.trim());
            else this.showSuccess();
            return;
          }
        }
        if (this.store('local', 'subscribed')) return;
        var closedAt = Number(this.store('local', 'closed-at') || 0);
        var days = Number(this.dataset.days || 0);
        var recentlyClosed = closedAt && Date.now() - closedAt < days * 864e5;
        if (recentlyClosed || this.store('session', 'closed')) {
          if (!this.store('session', 'tab-hidden')) this.showTab(true);
          return;
        }
        var delay = Math.max(0, Number(this.dataset.delay || 0)) * 1000;
        this.timer = setTimeout(() => this.autoOpen(), delay);
      }

      autoOpen() {
        var busy = document.querySelector('cart-drawer.is-open') || document.body.style.overflow === 'hidden';
        if (busy) { this.timer = setTimeout(() => this.autoOpen(), 3000); return; }
        this.open();
      }

      showTab(show) {
        if (this.tab) this.tab.hidden = !show;
      }

      open() {
        clearTimeout(this.timer);
        this.lastFocus = document.activeElement;
        this.overlay.hidden = false;
        this.dialog.hidden = false;
        this.showTab(false);
        requestAnimationFrame(() => this.classList.add('is-open'));
        this.prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        var input = this.dialog.querySelector('input[type="email"]');
        setTimeout(() => (input && !this.done ? input : this.dialog).focus({ preventScroll: true }), 60);
      }

      close(silent) {
        if (this.dialog.hidden) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = this.prevOverflow || '';
        setTimeout(() => { this.overlay.hidden = true; this.dialog.hidden = true; }, 250);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
        if (silent || this.designMode) { if (this.designMode) this.showTab(true); return; }
        if (this.done) return;
        this.store('local', 'closed-at', String(Date.now()));
        this.store('session', 'closed', '1');
        if (!this.store('session', 'tab-hidden')) this.showTab(true);
      }

      trapFocus(e) {
        var items = Array.from(this.dialog.querySelectorAll('a[href], button, input')).filter((el) => !el.disabled && el.offsetParent !== null);
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      showSuccess() {
        this.done = true;
        this.store('local', 'subscribed', '1');
        this.showTab(false);
        this.querySelector('[data-sp-step="form"]').hidden = true;
        this.querySelector('[data-sp-step="success"]').hidden = false;
        this.dialog.focus({ preventScroll: true });
      }

      showError(message) {
        var err = this.form && this.form.querySelector('[data-sp-error]');
        if (!err) return;
        err.textContent = message || this.dataset.error || 'Something went wrong. Please try again.';
        err.hidden = false;
      }

      shopifyProtectsForm() {
        if (!this.form) return false;
        if (this.form.dataset.hcaptchaBound || this.form.dataset.recaptchaBound) return true;
        if (this.form.submit !== HTMLFormElement.prototype.submit) return true;
        var type = this.form.querySelector('input[name="form_type"]');
        return !!(type && type.value === 'customer' && /\/contact/.test(this.form.action || ''));
      }

      nativeSubmit() {
        this.store('session', 'pending', '1');
        // form.submit is Shopify's hCaptcha wrapper once the form is bound.
        // HTMLFormElement.prototype.submit skips it and posts with no token.
        this.form.submit();
      }

      async submit(e) {
        // Let Shopify attach the CAPTCHA token and post the form. A fetch, or
        // prototype.submit(), sends no token and Shopify shows "Missing CAPTCHA token".
        if (this.shopifyProtectsForm()) {
          this.store('session', 'pending', '1');
          return;
        }
        e.preventDefault();
        var btn = this.form.querySelector('[data-sp-submit]');
        this.form.querySelector('[data-sp-error]').hidden = true;
        btn.classList.add('is-loading');
        var res;
        try {
          res = await fetch(this.form.action, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'text/html' } });
        } catch (error) {
          this.nativeSubmit();
          return;
        }
        try {
          if (/\/challenge/.test(res.url) || res.status === 403 || res.status === 429) { this.nativeSubmit(); return; }
          if (/customer_posted=true/.test(res.url)) { this.showSuccess(); return; }
          var html = await res.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var serverError = doc.querySelector('[data-sp-server-error]') || doc.querySelector('form[action*="/contact"] .errors');
          var message = serverError ? serverError.textContent.replace(/\s+/g, ' ').trim() : '';
          if (message) { this.showError(message); return; }
          if (doc.querySelector('[data-sp-posted]')) { this.showSuccess(); return; }
          console.warn('[mt-subscribe-popup] Unexpected response, falling back to page submit:', res.status, res.url);
          this.nativeSubmit();
        } finally {
          btn.classList.remove('is-loading');
        }
      }

      copyCode(btn) {
        var code = this.querySelector('[data-sp-code]').textContent.trim();
        var done = () => { var t = btn.textContent; btn.textContent = btn.dataset.copied || 'Copied'; setTimeout(() => { btn.textContent = t; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
